import React from "react";
import Reveal from "./Reveal";
import { WhatsAppButton, WhatsAppIcon } from "./WhatsApp";
import { waLink, WHATSAPP_NUMBER } from "../lib/site";

export default function Contact() {
  return (
    <section
      id="contact"
      className="relative bg-[#111] text-white py-28 md:py-40 overflow-hidden"
    >
      {/* subtle texture */}
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle at 25% 30%, #fff 0 1px, transparent 1px), radial-gradient(circle at 70% 60%, #fff 0 1px, transparent 1px)",
          backgroundSize: "40px 40px, 60px 60px",
        }}
      />

      <div className="relative max-w-[1100px] mx-auto px-6 sm:px-10 lg:px-14 text-center">
        <Reveal>
          <h2 className="serif text-[44px] sm:text-[64px] md:text-[88px] leading-[1.03] font-light">
            Ready to find your
            <br />
            <span className="italic">Magic Dress?</span>
          </h2>
        </Reveal>

        <Reveal delay={160}>
          <p className="sans text-[16px] leading-[1.85] text-white/85 max-w-[600px] mx-auto mt-8">
            Click below to chat with us directly on WhatsApp. We'll send the
            full brochure and this week's available prints, usually within
            the hour.
          </p>
        </Reveal>

        <Reveal delay={240}>
          <div className="mt-12 flex flex-col items-center gap-6">
            <WhatsAppButton
              testId="contact-cta-primary"
              variant="green"
              className="px-9 py-5 text-[12px]"
            >
              Chat with us for the full Brochure & Prints
            </WhatsAppButton>

            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[13px] sans tracking-luxe text-white/75 hover:text-white transition-colors duration-500"
              data-testid="contact-phone"
            >
              +44 7960 207829
            </a>
          </div>
        </Reveal>

        <Reveal delay={320}>
          <div className="mt-16" />
        </Reveal>
      </div>

      {/* Footer line */}
      <div className="relative mt-24 pt-8 border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-14 flex flex-col sm:flex-row items-center justify-between gap-4 text-[12px] sans tracking-luxe text-white/65">
          <div className="serif italic text-[15px] tracking-wider-elegant text-white/95">
            Rapallini
          </div>
          <div>© {new Date().getFullYear()} · Designed by Chanel Rapallini · London</div>
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 hover:text-white transition-colors duration-500"
            data-testid="footer-whatsapp"
          >
            <WhatsAppIcon className="w-3.5 h-3.5" />
            WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
